import React from 'react'
import Confetti from 'react-confetti'

export default  () => {
 
  return (
    <Confetti
    
    />
  )
}